<div class="modal-header">
    <div class="row col-12">
        <div class="modal-title col-10">
            <h4>{{ title }}</h4>
        </div>
        <div class="col-2 align-self-center">
            <div class="text-end">
                <button type="button" class="btn" aria-label="Close" (click)="dismiss()">
                    <span aria-hidden="true"><i class="fa-solid fa-x"></i></span>
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal-body" style="white-space: pre-line;">{{ message }}</div>
<div class="modal-footer">
    @if (btnCancelText) {
        <button type="button" class="btn btn-danger" (click)="decline()">{{ btnCancelText }}</button>
    }
    <button type="button" class="btn btn-success" (click)="accept()">{{ btnOkText }}</button>
</div>
